import { ObjectContainerClientT, ObjectTypeClientT } from 'bovaljaren-models';
import React, { ReactElement } from 'react';
import { formatValue } from '../../../../../utils/object.helper';
import { objectTypePropertySorting } from '../../../../../utils/objectType.helper';

type ObjectViewFactsProps={
    selectedObject?: ObjectContainerClientT;
    types?: ObjectTypeClientT[];
};

const ObjectViewFacts: React.FC<ObjectViewFactsProps> = ({ selectedObject, types }): ReactElement => {
    return (

        <div className='bv-objectview-facts'>
            {selectedObject?.data
                .slice()
                .filter(v => v.value !== null)
                .filter(v => types?.find(t => t.id === selectedObject.objectTypeId) ? types?.find(t => t.id === selectedObject.objectTypeId)?.properties.find(p => v.propId === p.id) : true)
                .sort(objectTypePropertySorting)
                .map(d => {
                    const property = types?.find(t => t.id === selectedObject.objectTypeId)?.properties.find(p => p.id === d.propId);

                    return ({ ...property, ...d });
                })
                .filter(d => d.type !== 'description' && d.type !== 'richDescription' && d.type !== 'externalUrl')
                .map((d, i) => {
                    return <div key={i}><b>{d.name}</b><br />{formatValue(d, d.type)} {d.ending}</div>;
                })}
        </div>

    );
};


export default ObjectViewFacts;